<template>
	<div class="app-bg-color-grey-dark app-padding-40 app-border-radius-8">
		<div @click="handleSubmitAddress"
			class="app-bg-color-red app-cursor-pointer app-border-radius-4 app-text-center app-font-color-white app-width-100 app-height-40 app-line-height-40">
			<font class="app-font-size-15">新增地址</font>
		</div>
		<div class="app-margin-top-20">
			<el-table border :data="tableData" size="medium" class=" app-margin-top-30" style="width: 100%"
				:header-cell-style="{ background: '#353740', color: '#909399', fontSize: '14px' }"
				:cell-style="{ background: '#F2F6FC',color: '#606266', fontSize: '14px' }">
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="phone" label="电话"></el-table-column>
				<el-table-column prop="provinceName" label="省"></el-table-column>
				<el-table-column prop="cityName" label="市"></el-table-column>
				<el-table-column prop="districtName" label="区"></el-table-column>
				<el-table-column prop="address" label="详细地址"></el-table-column>
				<el-table-column fixed="right" label="操作" width="150">
					<template slot-scope="scope">
						<el-button @click="handleUpdate(scope.row)" type="text" style="color: #0052D9;"
							icon="el-icon-edit">
							编辑</el-button>
						<el-button @click="handleDelete(scope.row)" type="text" style="color: #0052D9;"
							icon="el-icon-delete">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="app-pagination-container">
			<el-pagination v-if="pagination.total > 0" background @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="pagination.currentPage"
				:page-sizes="pagination.pageSizeArray" layout=" prev, pager, next, sizes, jumper"
				:page-size="pagination.pageSize" :page-count="pagination.pageCount"></el-pagination>
		</div>
		<submit-address ref="submitAddressRefs" @success="getList()"></submit-address>
	</div>
</template>
<script>
	import submitAddress from '../../components/printer/submitAddress';
	import service from '../../service/printer';
	import {
		mapState
	} from 'vuex';
	export default {
		inject: ['reload'],
		components: {
			submitAddress
		},
		computed: {
			...mapState({
				userInfo: state => state.userInfo.data
			})
		},
		data() {
			return {
				pagination: {
					pageCount: 1,
					currentPage: 1,
					pageSize: 5,
					total: 0,
					pageSizeArray: [10, 20, 30, 50]
				},
				tableData: []
			};
		},
		mounted() {
			//var ismac = sessionStorage.getItem('ismac');
			this.getList();
		},
		methods: {
			//设置表格行的样式
			tableRowStyle({
				row,
				rowIndex
			}) {
				return 'font-size:16px;'
			},
			//设置表头行的样式
			tableHeaderColor({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				return 'background-color:#3b3c3d;color:#fff;font-size:14px;text-align:center'

			},
			indexMethod(index) {
				return (this.pagination.currentPage - 1) * this.pagination.pageCount + index + 1;
			},
			getList() {
				this.tableData = [];
				service.findAddressListPage(this.pagination.currentPage, this.pagination.pageSize, this.userInfo.id,
					res => {
						this.tableData = res.data.records;
						this.pagination.total = res.data.total;
						this.pagination.pageCount = res.data.pages;
					});
			},
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.getList();
			},
			handleSubmitAddress() {
				this.$refs['submitAddressRefs'].handleAdd();
			},
			handleGoTask() {
				this.$router.push(
					'/printer/task'
				);
			},
			handleUpdate(row) {
				this.$refs['submitAddressRefs'].handleUpdate(row);
			},
			handleDelete(row) {
				this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						service.deleteAddress({
							id: row.id
						}, res => {
							if (res.code == 200 && res.success) {
								this.getList();
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
							} else {
								this.$message({
									type: 'error',
									message: '删除失败!'
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.device-item {
		padding: 33px 30px 53px;
		height: 113px;
		margin-bottom: 25px;
		display: flex;
		justify-content: space-between;

		.device-table {
			width: 750px;
			font-size: 16px;

			thead {
				color: #acacac;
				background-image: linear-gradient(to right, #979797 0%, #979797 50%, transparent 50%);
				background-size: 20px 1px;
				background-repeat: repeat-x;
				background-position: left bottom;

				tr {
					th {
						text-align: left;
						padding: 6px 0 26px;

						&:nth-child(1) {
							width: 25%;
						}

						&:nth-child(2) {
							width: 30%;
						}

						&:nth-child(3) {
							width: 45%;
						}
					}
				}
			}

			tbody {
				tr {
					td {
						padding-top: 26px;
					}
				}
			}
		}

		.device-operation {
			width: 149px;
			font-size: 24px;
			text-align: center;

			.device-edit {
				width: 149px;
				height: 56px;
				line-height: 56px;
				background: #c51f4b;
				border-radius: 28px;
				cursor: pointer;
			}

			.device-delete {
				width: 149px;
				height: 56px;
				line-height: 56px;
				background: #818181;
				border-radius: 28px;
				margin-top: 20px;
				cursor: pointer;
			}
		}
	}
</style>
